import { ObjectType, Field, InputType, Int, ID, registerEnumType } from 'type-graphql'

import { Group } from './group.js'

@InputType({ description: 'Input for creating a new board group.' })
export class NewGroup {
  @Field({ description: 'The name of the new group.' })
  name: string

  @Field({ nullable: true, description: 'A detailed description for the new group.' })
  description?: string
}

@InputType({ description: 'Input for updating (patching) an existing board group.' })
export class GroupPatch {
  @Field({ nullable: true, description: 'The new name for the group.' })
  name: string

  @Field({ nullable: true, description: 'The new description for the group.' })
  description?: string
}

@ObjectType({ description: 'A paginated list of board groups.' })
export class GroupList {
  @Field(type => [Group], { description: 'The list of group items.' })
  items: Group[]

  @Field(type => Int, { description: 'The total number of groups.' })
  total: number
}
